module.exports = __webpack_public_path__ + "static/media/ExampleLabel.22ae30e6.png";